import { render } from "./ProdutoCheckoutView.vue?vue&type=template&id=6793b004&scoped=true"
import script from "./ProdutoCheckoutView.vue?vue&type=script&lang=js"
export * from "./ProdutoCheckoutView.vue?vue&type=script&lang=js"

import "./ProdutoCheckoutView.vue?vue&type=style&index=0&id=6793b004&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6793b004"]])

export default __exports__